import { ReactNode } from "react";
import {
  Box,
  Drawer as MuiDrawer,
  DrawerProps as MuiDrawerProps,
  SvgIcon,
  withStyles,
  createStyles,
  Theme,
  Typography,
  IconButton,
} from "@material-ui/core";

import { Close } from "~components/Icons";

import { makeStyles } from "@material-ui/core";

type DrawerProps = {
  onClose: () => void;
} & MuiDrawerProps;

interface Styles {
  closeButton?: string;
  root?: string;
  title?: string;
  buttonGroup?: string;
}

type HeaderProps = {
  classes: Styles;
  title: string;
  onClose: () => void;
};

type ContentProps = {
  children: ReactNode;
};

type FooterProps = {
  classes: Styles;
  children: ReactNode;
};

const Header = withStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",

      paddingTop: theme.spacing(2.5),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(2.25),
      paddingLeft: theme.spacing(4.5),
      boxShadow: "0 0 1px 0 rgba(10, 31, 68, 0.1)",
      position: "sticky",
      top: 0,
      backgroundColor: "white",
    },
    closeButton: {
      width: 42,
      height: 42,
      marginLeft: theme.spacing(3),

      fontSize: 13,
      color: theme.palette.primary.main,
    },
    title: {
      fontSize: 22,
      fontWeight: 600,
      lineHeight: "normal",
      color: theme.palette.dark.main,
    },
  }),
)(({ title, onClose, classes }: HeaderProps) => (
  <Box className={classes.root}>
    <Typography variant="h3" className={classes.title}>
      {title}
    </Typography>
    <IconButton onClick={onClose} className={classes.closeButton}>
      <SvgIcon component={Close} />
    </IconButton>
  </Box>
));

const Content = ({ children }: ContentProps) => <Box flex={1}>{children}</Box>;

const Footer = withStyles((theme: Theme) =>
  createStyles({
    buttonGroup: {
      alignSelf: "flex-end",

      padding: `${theme.spacing(0)}px ${theme.spacing(2)}px ${theme.spacing(2)}px`,

      "& > button:not(:first-child)": {
        marginLeft: theme.spacing(1),
      },
    },
  }),
)(({ classes, children }: FooterProps) => <Box className={classes.buttonGroup}>{children}</Box>);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",

      width: "38%",
      minWidth: 320,

      boxShadow: "0 24px 30px 0 rgba(51, 91, 130, 0.12), 0 0 1px 0 rgba(10, 31, 68, 0.1)",
    },
  }),
);

export const Drawer = ({ onClose, children, ...rest }: DrawerProps) => {
  const classes = useStyles();
  return (
    <MuiDrawer {...rest} classes={{ paper: classes?.paper }} onClose={onClose} anchor="right">
      {children}
    </MuiDrawer>
  );
};

Drawer.Header = Header;
Drawer.Content = Content;
Drawer.Footer = Footer;
